import { createFileRoute } from '@tanstack/react-router';

import { PlacementEditorPage } from '../features/supply/placements/components/PlacementEditorPage';

export const Route = createFileRoute('/supply/placements_/edit/$placementId')({
  component: EditPlacementRoute,
});

function EditPlacementRoute() {
  const { placementId } = Route.useParams();
  return <PlacementEditorPage placementId={placementId} />;
}
